var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgThermometerFilled = function SvgThermometerFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5C9.27614 4.5 9.5 4.72386 9.5 5V17.1338C9.7989 17.3067 10 17.6299 10 18C10 18.5523 9.55228 19 9 19C8.44772 19 8 18.5523 8 18C8 17.6299 8.2011 17.3067 8.5 17.1338V11.0669V5C8.5 4.72386 8.72386 4.5 9 4.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.3542V5C12 3.34315 10.6569 2 9 2C7.34315 2 6 3.34315 6 5V15.3542C5.37764 16.0593 5 16.9856 5 18C5 20.2091 6.79086 22 9 22C11.2091 22 13 20.2091 13 18C13 16.9856 12.6224 16.0593 12 15.3542ZM10 16.2676V5C10 4.44772 9.55228 4 9 4C8.44772 4 8 4.44772 8 5V16.2676C7.4022 16.6134 7 17.2597 7 18C7 19.1046 7.89543 20 9 20C10.1046 20 11 19.1046 11 18C11 17.2597 10.5978 16.6134 10 16.2676Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7C19 8.65685 17.6569 10 16 10C14.3431 10 13 8.65685 13 7C13 5.34315 14.3431 4 16 4C17.6569 4 19 5.34315 19 7Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThermometerFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thermometer-filled.c8c43639.svg";
export { ForwardRef as ReactComponent };